import type { SortDirection } from '@/models/listPage';

export type { SortDirection };

export interface Sort<Key extends string> {
  key: Key;
  direction: SortDirection;
}

/** Tri suivant : la même colonne inverse l'ordre, une autre colonne repart en croissant */
export function nextSort<Key extends string>(current: Sort<Key>, key: Key): Sort<Key> {
  return current.key === key
    ? { key, direction: current.direction === 'asc' ? 'desc' : 'asc' }
    : { key, direction: 'asc' };
}
